import { PageEvent } from '@angular/material/paginator';

export interface CaEntityState<EntityType> {
  creating: boolean;
  entities: { [id: string]: EntityType };
  error: string;
  ids: Array<string>;
  loadingAll: boolean;
  loadingEntities: { [key: string]: boolean };
  paginators: {
    [key: string]: {
      ids: Array<string>;
      complete: boolean;
      loading: boolean;
      page?: PageEvent;
      filter?: any;
      error?: any;
      isDefault?: boolean;
    };
  };
  selectedId?: string;
  searchResults: string[];
  searching: boolean;
  updatedAt: { [key: string]: number };
  page: PageEvent;
  filter: any;
}

export const INITIAL_ENTITY_STATE: CaEntityState<any> = {
  creating: false,
  entities: {},
  error: '',
  ids: [],
  loadingAll: false,
  loadingEntities: {},
  searchResults: [],
  searching: false,
  paginators: {},
  page: {
    pageIndex: 0,
    pageSize: 20,
    length: 0,
  },
  filter: {},
  updatedAt: {},
};
